import { connect } from 'react-redux';
import AliasesList from "./AliasesList";
import { 
    fetchGetAliases, 
    fetchUpdateAlias, 
    getAliasesData, 
    loadingAliases, 
    fetchSetDefaultAlias 
} from "../../../../reducers/account/aliases";
import { getTranslation } from "../../../../reducers/common/localization";
import { MODAL_REMOVE_ALIAS, MODAL_ADD_ALIAS, showModal } from "../../../../reducers/common/activeModal";

const mapStateToProps = state => {
    return {
        loading: loadingAliases(state),
        data: getAliasesData(state),
        translation: getTranslation(state)
    };
};

const mapDispatchToProps = dispatch => {
    return {
        onGetAliases: () => dispatch(fetchGetAliases()),
        onOpenRemoveAliasModal: () => {
            dispatch(showModal({ modalKey: MODAL_REMOVE_ALIAS }))
        },
        onOpenAddAliasModal: () => {
            dispatch(showModal({ modalKey: MODAL_ADD_ALIAS }))
        },
        onChangeExpose: (id, data) => {
            dispatch(fetchUpdateAlias(id, data));
        },
        onSetDefaultAlias: (data) => {
            dispatch(fetchSetDefaultAlias(data));
        }
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(AliasesList);



// WEBPACK FOOTER //
// ./src/components/accountManagement/aliasesManagement/aliasesList/AliasesList.container.js